import {ReactElement, useState} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {PAGE_FRAGMENT_SMD_WIDTH, PD_LG} from "@/shared/dimens";
import {Button, TextareaAutosize, Typography} from "@mui/material";

export function EditTextFragment(props: {
  value: string,
  setValue: (value: string) => void,
  onCancel: () => void,
}): ReactElement {
  const [text, setText] = useState<string>(props.value);
  return <StyledBoxColumn style={{padding: PD_LG, width: "84dvw", maxWidth: PAGE_FRAGMENT_SMD_WIDTH}}>
    <Typography variant="h6">Edit Text</Typography>
    <TextareaAutosize
      minRows={8}
      style={{fontSize: 24}}
      value={text} onChange={e => setText(e.target.value)}/>
    <StyledBoxRow>
      <Button onClick={props.onCancel}>Cancel</Button>
      <StyledSpan/>
      <Button variant={"contained"} onClick={() => props.setValue(text)}>Apply</Button>
    </StyledBoxRow>
  </StyledBoxColumn>;
}